import { useMemo } from 'react'
import { useLocation, matchPath } from 'react-router-dom'

import { PROVIDERS } from 'consts'
import { useAuth } from 'contexts/AuthContext'
import { PATHNAMES } from 'utils/routes/consts'

const useIsMobileAllowedRoute = () => {
  const location = useLocation()
  const { keycloak } = useAuth()

  const isUserAuthenticated = keycloak.authenticated

  const isAllowedRoute = useMemo(() => {
    const pathname = location.pathname
    const split = pathname.split('/')

    const providersList = Object.keys(PROVIDERS)

    const isHomepageRedirect = matchPath(location?.pathname, { path: PATHNAMES.HOME, exact: true })
    const isLoginPage = matchPath(location?.pathname, { path: PATHNAMES.LOGIN, exact: true })
    const isLogoutPage = matchPath(location?.pathname, { path: PATHNAMES.LOGOUT, exact: true })

    const isPublicDashboard = split[1] === 'public' && split[2] === 'dashboard'
    const isPostPage =
      matchPath(location?.pathname, { path: PATHNAMES.WORKSPACE_VIDEO_MODAL, exact: true }) &&
      providersList.includes(split[2])
    const isPublicCreatorPage = split[1] === 'group' && !isUserAuthenticated
    const isPublicJobDashboard = split[1] === 'public' && split[2] === 'dashboard'
    const isJobDashboard =
      split[1] === 'workspace' && split[3] === 'jobs' && split[5] === 'dashboard' && isUserAuthenticated

    const isWorkspaceDashboardsPage =
      matchPath(location?.pathname, { path: PATHNAMES.WORKSPACE_DASHBOARDS, exact: true }) && isUserAuthenticated
    const isBrandCategoryPage = matchPath(location?.pathname, {
      path: PATHNAMES.OUTDATED_WORKSPACE_CATEGORY,
      exact: true,
    })
    const isZaiChatPage = matchPath(location?.pathname, { path: PATHNAMES.WORKSPACE_ZAI, exact: true })
    const isZaiAnswerChatPage = matchPath(location?.pathname, { path: PATHNAMES.WORKSPACE_ZAI_ANSWER, exact: true })
    const isCategoryRedirectPage = matchPath(location?.pathname, { path: PATHNAMES.OUTDATED_CATEGORY, exact: true })
    const isBrandRankingPage = matchPath(location?.pathname, {
      path: PATHNAMES.OUTDATED_WORKSPACE_CATEGORY_RANKING,
      exact: true,
    })

    const isDashboardsRedirectPage = matchPath(location?.pathname, { path: PATHNAMES.DASHBOARDS, exact: true })

    const isSoaRedirectPage = matchPath(location?.pathname, {
      path: PATHNAMES.SOA,
      exact: true,
    })
    const isSoaPage = matchPath(location?.pathname, {
      path: PATHNAMES.WORKSPACE_SOA,
      exact: true,
    })
    const isSoaRankingPage = matchPath(location?.pathname, {
      path: PATHNAMES.WORKSPACE_SOA_RANKING,
      exact: true,
    })

    const allowedRoutes = [
      isHomepageRedirect,
      isLoginPage,
      isLogoutPage,
      isPublicDashboard,
      isPostPage,
      isPublicCreatorPage,
      isPublicJobDashboard,
      isJobDashboard,
      isWorkspaceDashboardsPage,
      isBrandCategoryPage,
      isCategoryRedirectPage,
      isBrandRankingPage,
      isZaiChatPage,
      isZaiAnswerChatPage,
      isDashboardsRedirectPage,
      isSoaRedirectPage,
      isSoaPage,
      isSoaRankingPage,
    ]

    return allowedRoutes.some(Boolean)
  }, [location?.pathname, isUserAuthenticated])

  return isAllowedRoute
}

export default useIsMobileAllowedRoute
